import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { Rating } from 'src/app/models/exercise.model';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Rating } from 'src/app/shared/models/exercise.model';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {

  @Input() index: any;
  @Input() exerciseTimetrackingdata;
  _element: Rating;
  _answer: string;
  radioSelected: string;
  @Input() id: string;
  @Input() points: any;
 
  @Input() variableFeedback: any;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() isSubmitted: boolean = false;
  @Input() isResultPublished: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() fixedEditor: any;
  
  questionChecked: boolean = false;
  @Input() set element(element) {
    this._element = element;
  }
  @Input() set answer(answer) {
    this._answer = answer;
    if(this._answer){
      this.questionChecked = true;
      this.radioSelected = this._answer;
    }
  }

  @Output() onValueChange = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() questionBlos;

  constructor(private _scrollToService: ScrollToService) { }
  ngOnInit() {
  }

  backHandler() {
    this.back.emit(true);
  }

  next(event) {
    this.onValueChange.emit({ elementId: this.id, answer: event });
    // const config: ScrollToConfigOptions = {
    //   target: 'destination' + (this.index + 1)
    // };
    // this._scrollToService.scrollTo(config)
  }
  check() {
    this.questionChecked = true;
    this.onReview.emit({ elementId: this.id, answer: this.radioSelected });
  }
  skip() {
    this.onValueChange.emit({ elementId: this.id, answer: '' });
  }
  _reportFeedback(value) {
    this.reportFeedback.emit(value);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }
}
